<template>
    <div>
        <div><span>{{ $t('chats.attach-file') }}</span></div>
        <base-select class="mt-1" clearable avoidDefaultSort :loading="false" :options="fileTags" valueProp="id" label="name" v-model="fileTag" :placeholder="$t('chats.select-file-type')"></base-select>
        <div v-if="fileTag" class="mt-2">
            <base-button class="attach-button" @click="$refs.fileInput.click()"><b-icon-paperclip class="mr-2"></b-icon-paperclip><span>{{ $t('chats.select-file') }}</span><input type="file" ref="fileInput" @change="uploadFile($event)" class="d-none"/></base-button>
        </div>
        <div v-if="files.length" class="mt-2">
            <div v-for="(file, index) in files" :key="index" class="file-item">
                <span class="file-icon">{{ getFileIcon(file) }}</span>
                <span class="file-name">{{ file.name }}</span>
                <base-button @click="removeFile(index)" red><b-icon-trash></b-icon-trash></base-button>
            </div>
        </div>
        <div v-if="showLink">

        </div>
    </div>
</template>

<script>
import FilesRepository from '@/repositories/FilesRepository'
import BaseButton from '@/components/base/buttons/BaseButton.vue'
import { BIcon } from 'bootstrap-vue'

export default {
  components: { BaseButton, BIcon },
    data () {
        return {
            fileTags: [],
            fileTag: null,
            files: []
        }
    },
    created () {
        FilesRepository.getFilesTags().then((response) => {
          this.fileTags = response.data.map(tag => ({id: tag.id, name: this.$i18nHelpers.normalize(tag.name)}))
        })
    },
    methods: {
        uploadFile (event) {
            this.files.push(event.target.files[0])
        },
        getFileIcon (file) {
            const fileType = file.type.split('/')[0]
            if (fileType === 'image') return '🖼️'
            if (fileType === 'application') return '📄'
            return '📁'
        },
        removeFile (index) {
            this.files.splice(index, 1)
        }
    },
    computed: {

    }
}
</script>

<style lang="scss" scoped >
.attach-button {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/base/forms/AttachFile.vue